import { AnyAction } from 'typescript-fsa';
import { GridRowId } from '@mui/x-data-grid';

export enum SidebarOpenMode {
  None,
  View,
  Edit,
  Create,
  Copy,
}

export type OpenSidebarActionCreator<R> = (id: GridRowId, type?: IDetailsPayload['type'], row?: R) => AnyAction;

export interface IDetailsPayload {
  mode: SidebarOpenMode;
  id?: string | number;
  type?: string;
}

export interface IDetailsSidebarClosePayload {
  /** Close without the "Unsaved changes" dialog, e.g. when the opened entity is being deleted. */
  skipUnsavedChangesConfirmation?: boolean;
}

export type IDetailsSidebarStore = IDetailsPayload;

export interface IDetailsSidebarStoreSegment {
  detailsSidebar: IDetailsSidebarStore;
}
